import React from 'react';
import { useFormContext, get } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { Field, RadioGroup as RadioGroup$1, Radio } from '@panwds/react-ui';
import { requiredMessage } from '../../messages.esm.js';

/**
 * Group radios together into a field and is connected to the form.
 *
 * All extra props are passed to the RadioGroup wrapping the radios.
 */
const RadioGroup = (props) => {
    var _a;
    const { name, label, items, register: registerOptions = {}, defaultValue, description, tooltip, disabled, showLabel, ...rest } = props;
    const context = useFormContext();
    const intl = useIntl();
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development" && context === null) {
        throw new Error("Attempted to render RadioGroup outside of a Form context. Make sure your component is rendered inside <Form>.");
    }
    const { formState, register } = context;
    registerOptions.required =
        registerOptions.required === false
            ? registerOptions.required
            : intl.formatMessage(requiredMessage, {
                label,
            });
    return (React.createElement(Field, { label: label, optional: !registerOptions.required, control: React.createElement(RadioGroup$1, { ...rest, value: defaultValue, ...register(name, registerOptions), disabled: disabled }, items.map((item) => (React.createElement(Radio, { key: item.value, ...item })))), error: (_a = get(formState.errors, name)) === null || _a === void 0 ? void 0 : _a.message, description: description, tooltip: tooltip, disabled: disabled, connectLabel: false, showLabel: showLabel, requiredAsterisk: rest.requiredAsterisk }));
};

export { RadioGroup };
//# sourceMappingURL=RadioGroup.esm.js.map
